export const EMPTY_TASK_TYPES_OPTIONS = [];
